"use client";

import { Faq3Section } from "./faqs3/Faq3Section";

const Faqs3 = (props: Parameters<typeof Faq3Section>[0]) => <Faq3Section {...props} />;

export default Faqs3;
